import { closeDialog } from "./dialogManager.js";
import { currentTable } from "../../../../../app/viewManager.js";
import { currentContext } from "./dialogContext.js";

export const withClose = (action) => async () => { if (await action() != true) closeDialog(); };

export function onCreate(action, cls = "row-flash-create") {
    return withClose(async () => {
        const result = await action();
        if (result && result !== true) animateRow(result.id, cls);
        return result;
    });
}

export function onEdit(action, cls = "row-flash-update") {
    return withClose(async () => {
        const result = await action(currentContext.id);
        if (result && result !== true) animateRow(currentContext.id, cls);
        return result;
    });
}

export function onDelete(action) {
    return withClose(() => action(currentContext.id));
}

export function chainSetup(handlers, promise) {
    handlers.setupPromise = handlers.setupPromise ? Promise.all([handlers.setupPromise, promise]) : promise;
}

export function animateRow(id, cls) {
    setTimeout(async () => {
        const rows = currentTable?.getRows() ?? [];
        const row = rows.find(row => {
            const rowData = row.getData();
            return rowData.id == id || rowData.projectId == id;
        });
        if (!row) return;

        // The row may sit on another page; jump there so it is rendered before it is animated.
        try { await currentTable.setPageToRow(row); } catch (_) {}

        const element = row.getElement();
        if (!element) return;

        element.classList.remove(cls);
        void element.offsetWidth;
        element.classList.add(cls);
        setTimeout(() => element.classList.remove(cls), 1900);
    }, 100);
}
